import { Attributes, LookupBase } from '@singularsystems/neo-core';
import { AllocationsMadeInValue } from '../Enums/AllocationsMadeInValue';

export default class AMIncentiveGroupUsedBudgetLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public incentiveGroupId: number = 0;

    @Attributes.Integer()
    public budgetUsedFaceValue: number = 0;

    @Attributes.Integer()
    public budgetUsedFairValue: number = 0;

    public allocationValueType: AllocationsMadeInValue | null = null;

    // Client only properties / methods
}